export default __webpack_public_path__ + "74aac43b0dfc26b0f5fb559e5489af7e.svg";